import React from 'react'
import { lang } from 'utils/helpers'
import { languages } from 'utils/languages'

export const getLanguagesOptios = (params = {}) => {
  const { allowed } = params
  if (!Array.isArray(allowed) || !allowed.length) return []

  const languagesOptions = []
  for (const locale of allowed) {
    const language = languages.find(l => l.value === locale)

    if (language) {
      languagesOptions.push({
        ...language,
        label: lang(language.label)
      })
    }
  }

  return languagesOptions
}

export const renderFlag = (locale) => {
  let langValue = locale
  if (locale === 'en') langValue = 'gb'

  return <span className={`fi fi-${langValue} fis lang-selector__flag`} />
}
